
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { IGallery } from "../../../../../services";
import { i18nManager } from "../../../../../i18n";
import styles from "../../assets/style.module.css";
import { alertDialog, FileHelper, fileInputBuildFileInputPreview, FileInputPreviewType } from "@rivtn/noseur";

export interface GalleryItemProps {
    gallery: IGallery;
}

function GalleryItem({ gallery: g }: GalleryItemProps) {

    const previewType = FileHelper.detectPreviewTypeFromUrl(g.media_location + (g.extra_data?.extension ?? ""));
    const isImage = previewType === FileInputPreviewType.IMAGE;
    const caption = g.caption || g.extra_data?.tags?.join(" · ");

    const openPreview = () => {
        if (!isImage) return;
        alertDialog({
            cancel: null,
            confirm: {
                label: i18nManager.Labels.gallery.close,
                props: {
                    textOnly: true,
                    style: { color: "var(--text)" }
                }
            },
            componentProps: {
                maximized: true,
                contentProps: {
                    style: { background: "var(--deep)" },
                }
            },
            message: fileInputBuildFileInputPreview({
                previewType,
                url: g.media_location,
                style: { margin: "auto" }
            })
        }).show();
    };

    return (<div className={styles["gal-item"]} onClick={openPreview}>
        {fileInputBuildFileInputPreview({
            previewType,
            url: g.media_location,
            style: { width: "100%", height: "100%" }
        })}
        {(g.action_location || g.action_label) && (
            <ReactRouterDom.NavLink target="_blank" to={g.action_location} className={styles["card-badge"]} onClick={(e) => e.stopPropagation()}>
                {g.action_label ?? g.extra_data?.tags?.join(", ")}
            </ReactRouterDom.NavLink>
        )}
        {caption && (<div className={styles["gal-caption"]}>{caption}</div>)}
    </div>);
}

export default GalleryItem;
